import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

function PopularInstructor() {
  const [t, i18n] = useTranslation("global");
  const [instructors, setInstructors] = useState([]);

  useEffect(() => {
    const fetchPopularInstructors = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/most-instructors`, {
          headers: {
            "Accept-Language": i18n.language,
          },
        });
        
        const data = await response.json();
        if (data.status === "success") {
          setInstructors(data.data);
        } else {
          console.error("Error fetching instructors:", data.message);
        }
      } catch (error) {
        console.error("Error fetching instructors:", error);
      }
    };

    fetchPopularInstructors();
  }, [i18n.language]);

  return (
    <section className="container">
      <div className="mt-5">
        <h1 className="main-color main-color-2 text-center">
          {t("instructors.titleOne")} <br /> {t("instructors.titleTwo")}
        </h1>
        <p className="text-center paragraph-color">
          {t("instructors.description")}
        </p>
      </div>

      <div className="container">
        <div className="row justify-content-center text-center">
          {instructors.length > 0 ? (
            instructors.map((instructor) => (
              <div
                key={instructor.id}
                className="col-lg-4 col-md-6 mb-3 d-flex justify-content-center"
              >
                <Link to={`/instructortDetails/${instructor.id}`} className="card p-3 text-decoration-none">
                  <img
                    style={{ width: "400px", maxWidth: "100%", height : "350px" }}
                    src={instructor.image}
                    className="card-img-top img-instructor"
                    alt={instructor.name}
                  />
                  <div className="card-body">
                    <h5 className="card-title fw-bold main-color">
                      {instructor.name}
                    </h5>
                    <p className="card-text paragraph-color">
                      {instructor.position}
                    </p>
                  </div>
                </Link>
              </div>
            ))
          ) : (
            <p>{t("instructors.noPopularInstructors")}</p>
          )}
        </div>
      </div>
    </section>
  );
}

export default PopularInstructor;
